import script from "./CheckoutClienteNovoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutClienteNovoForm.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutClienteNovoForm.vue?vue&type=style&index=0&id=e96f21f8&scoped=true&lang=css"

import exportComponent from "/media/alexandre/08eeec93-1efa-4ec5-9b9c-83fb7789c963/Projects/uniboi-app-2023/uniboi-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e96f21f8"]])

export default __exports__